import React from "react";
import { StyleSheet, View, ViewProps } from "react-native";

import {
  PdAccordionButton,
  PdAccordionIcon,
  PdAccordionItem,
  PdAccordionPanel,
} from "src/components/disclosure/accordion";
import { PdText } from "src/components/layout";
import { kStyleConst } from "src/kStyle";

export const ReferBrandsFaq: React.FC<ViewProps> = (props) => {
  const [item, setItem] = React.useState<
    | "how-submit"
    | "what-my-earning"
    | "when-my-credit"
    | "how-use-my-earned"
    | "invited-brand"
    | "what-many-retailers"
    | "brand-invited"
  >("how-submit");

  return (
    <View {...props}>
      <PdText variant="subheader" style={styles.mb4}>
        FAQs
      </PdText>
      <PdAccordionItem isOpened={item === "how-submit"}>
        <PdAccordionButton onPress={() => setItem("how-submit")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>How do I submit a brand referral?</PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText style={styles.mb2}>
            Simply send an e-mail we&apos;ve pre-written for you! You can invite up to 100 brands at a time (we do limit
            this to avoid spam) and the brands will receive the message from you. You will see your invited email
            address on the above table, and their status.
          </PdText>
          <PdText>
            You can also use your unique link and share with your brands via text, chat, email, and other forms of
            communication.
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "what-my-earning"}>
        <PdAccordionButton onPress={() => setItem("what-my-earning")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>What is my earning potential?</PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>
            For every new brand you invite that joins us, you can earn up to $2,000! $100 is instantly granted to you
            once the brand joins and activates their store front. In addition, you will also earn 3% of on new orders
            this brand receives from other retailers, for the first 45 days after the brand becomes activated. All in,
            you can earn up to $2,000 in total!
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "when-my-credit"}>
        <PdAccordionButton onPress={() => setItem("when-my-credit")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>
            When will my credit become available?
          </PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText style={styles.mb2}>
            Your $100 Main Tab credit becomes available to use instantly once the brand you invited activates their
            storefront. The 3% credit from other retailers orders will become available once those orders are shipped by
            the brand.
          </PdText>
          <PdText style={styles.fontMedium}>
            Please note that if your store is past due on NET payments, your credit may be withheld until your account
            is in good standing again.
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "how-use-my-earned"}>
        <PdAccordionButton onPress={() => setItem("how-use-my-earned")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>How can I use my earned credit?</PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>
            Your available credit will be displayed in your checkout cart section. You can apply credit to any orders
            you&apos;d like to by simply clicking a checkbox. You can then proceed to check out the order normally with
            terms or a credit card payment and the order will be submitted to the brand. Once the brand approves and
            ships the order, your Main Tab credit will be deposited directly into your bank account!
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "invited-brand"}>
        <PdAccordionButton onPress={() => setItem("invited-brand")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>
            I invited a brand and was instantly connected but there is no earned credit.
          </PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>
            Retailers are only eligible to earn credit for new brands they invite to the marketplace. If you invited a
            brand and they already have an active account with us, then this invite is ineligible for credit.
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "what-many-retailers"}>
        <PdAccordionButton onPress={() => setItem("what-many-retailers")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>
            What if many retailers invite the same brand?
          </PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>The retailer&apos;s link the brand signs up with will receive the credit!</PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "brand-invited"}>
        <PdAccordionButton onPress={() => setItem("brand-invited")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>
            A brand I invited didn&apos;t receive the automated email.
          </PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>
            It&apos;s possible they missed it or the email went into their spam folder. You can invite brands who still
            have &apos;invited&apos; status up to 3 times or simply share the unique link with them!
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
    </View>
  );
};

export const ReferSalesRepsFaq: React.FC<ViewProps> = (props) => {
  const [item, setItem] = React.useState<"how-submit" | "how-submit-2" | "how-submit-3">("how-submit");

  return (
    <View {...props}>
      <PdText variant="subheader" style={styles.mb4}>
        FAQs
      </PdText>
      <PdAccordionItem isOpened={item === "how-submit"}>
        <PdAccordionButton onPress={() => setItem("how-submit")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>
            How do I submit a sales rep referral?
          </PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam quis nostrud.
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "how-submit-2"}>
        <PdAccordionButton onPress={() => setItem("how-submit-2")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>How do I submit a brand referral?</PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam quis nostrud.
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
      <PdAccordionItem isOpened={item === "how-submit-3"}>
        <PdAccordionButton onPress={() => setItem("how-submit-3")}>
          <PdText style={[styles.flex1, styles.fontMedium, styles.fontLg]}>How do I submit a brand referral?</PdText>
          <PdAccordionIcon />
        </PdAccordionButton>
        <PdAccordionPanel>
          <PdText>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam quis nostrud.
          </PdText>
        </PdAccordionPanel>
      </PdAccordionItem>
    </View>
  );
};

const styles = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  fontLg: {
    fontSize: 16,
  },
  fontMedium: {
    fontWeight: "400",
  },
  mb2: {
    marginBottom: kStyleConst.kSpacing * 2,
  },
  mb4: {
    marginBottom: kStyleConst.kSpacing * 4,
  },
});
